import { TABLE_CHECKED_STATUS } from 'utils/constants';

/**
 * Selection rules shared by the tables that select panelists with the
 * "select all / select count / select visible" dropdown — the study participants
 * table and the Panelists page. Each page keeps its own selection state; these only
 * encode the rules both must agree on.
 */

/**
 * Whether the selection is resolved by the server from the current filters/search
 * ("select all", "select count") rather than being explicit person ids. Such a
 * selection must be cleared when its filters/search change, or the count the user
 * saw drifts from who the action reaches (PFOX-1284). Explicit ids are kept, so a
 * list can be built across several searches (PFOX-1315).
 *
 * @param {string} status One of `TABLE_CHECKED_STATUS`.
 * @returns {boolean}
 */
export const isServerResolvedSelection = status =>
    status === TABLE_CHECKED_STATUS.ALL || status === TABLE_CHECKED_STATUS.CUSTOM;

/**
 * How many people the selection resolves to.
 *
 * @param {Object} selection
 * @param {string} selection.status One of `TABLE_CHECKED_STATUS`.
 * @param {number} selection.total Size of the whole filtered/searched result set.
 * @param {number} selection.customCount The number requested via "select count".
 * @param {number} selection.checkedCount How many people are explicitly checked.
 * @returns {number}
 */
export const getSelectionCount = ({ status, total, customCount, checkedCount }) => {
    if (status === TABLE_CHECKED_STATUS.ALL) return total;
    if (status === TABLE_CHECKED_STATUS.CUSTOM) return customCount;

    return checkedCount;
};

/**
 * Toast shown when a server-resolved selection is cleared.
 *
 * @param {string} reason Completes the sentence, e.g. "the search changed".
 * @returns {string}
 */
export const selectionClearedMessage = reason => `Selection cleared because ${reason}.`;
